module.exports = __webpack_public_path__ + "static/event-startup-day-28b64e7acfe45bc62e62e51306748fb8.jpg";